import { getSkillsListQueryOptions, type ForManagerLocationDetail } from "@sidegigllc/api/client";
import { findAProQueryOptions } from "api/queries/findAPro";
import type { ConnectSearchParams } from "domains/connect/routing";
import { allGroupsQuery } from "domains/pros/containers/GroupDetail/queries";
import type { WarmableQuery } from "routing/warmQueries";

export type QueriesInput = {
  search: ConnectSearchParams;
  marketId: number;
  location?: ForManagerLocationDetail;
};

export const prosQuery = ({ search, marketId, location }: QueriesInput) =>
  findAProQueryOptions({
    page_size: 20,
    ...search,
    ordering: search.ordering ?? "gigs_worked",
    market_id: marketId,
    location_id: location?.id,
  });

export const skillGroupSkillsQuery = ({ search }: QueriesInput) =>
  getSkillsListQueryOptions(
    { query: "ordered_by_popularity" },
    { query: { enabled: !!search.skill_group, staleTime: Number.POSITIVE_INFINITY } },
  );

export const skillsWithDefaultsQuery = () =>
  getSkillsListQueryOptions(
    { include_defaults: true, include_recommendations: true, query: "ordered_by_popularity" },
    { query: { staleTime: Number.POSITIVE_INFINITY } },
  );

export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  prosQuery(input),
  skillGroupSkillsQuery(input),
  skillsWithDefaultsQuery(),
  allGroupsQuery(input),
];
